<template>
  <v-layout fill-height justify-center align-center>
    <div v-html="error" class="text-xs-center"></div>
  </v-layout>
</template>

<script>
export default {
  name: "ErrorView",

  props: {
    error: {
      type: String,
      default: '<div class="display-4">404 <br /> Not Found</div>'
    }
  }
};
</script>
